import script from "./CardBudgetComparison.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBudgetComparison.vue?vue&type=script&setup=true&lang=js"

import "./CardBudgetComparison.vue?vue&type=style&index=0&id=715d5614&lang=css"
import "./budget/budgetCard.css?vue&type=style&index=1&id=715d5614&scoped=true&lang=css"
import "./CardBudgetComparison.vue?vue&type=style&index=2&id=715d5614&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-715d5614"]])

export default __exports__